// Public: Enum that is used to represent the different selection states for a
// selectAll checkbox.
export default {
  ALL: 1,
  NONE: 0,
  INDETERMINATE: -1,
}
